import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Header from "../Header"
import Footer from "../Footer"
import { Row, Col, Container } from "reactstrap"
import "./chatbot.css"
import prettier from "prettier/standalone"
import parserBabel from "prettier/parser-babel"
import Filter from "./Filter"
import ChatContainer from "./ChatContainer"
import Feedback from "./Feedback"
import ChatbotApi from "../../api/ChatbotAPI"
import TraindexApi from "../../api/TraindexAPI"
import CloudWatchApi from "../../api/CloudWatchAPI"

const sendToCloudWatch = (executionTime) => {
  CloudWatchApi.logExecutionTime(executionTime).catch((err) => {
    console.error("Error sending data to CloudWatch:", err)
  })
}

export function sendLogToCloudWatch(logGroupName, logData) {
  CloudWatchApi.logMessage(logGroupName, logData).catch((err) => {
    console.log(err)
  })
}

const P_VALUES = ["Before", "After", "Equal"]

const Chatbot = ({ authorize }) => {
  const [priorityDValue, setPriorityDValue] = useState("")
  const [publicationDValue, setPublicationDValue] = useState("")
  const [cpcValue, setcpcValue] = useState("")
  const [kindCodeValue, setkindCodeValue] = useState("")
  const [priorityCondition, setPriorityCondition] = useState(P_VALUES[0])
  const [publicationCondition, setPublicationCondition] = useState(P_VALUES[0])
  const [threadData, setThreadData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState("Test error")

  const handlePriorityDChange = (event) => {
    setPriorityDValue(event.target.value)
  }
  const handlePublicaionDChange = (event) => {
    setPublicationDValue(event.target.value)
  }
  const cpcHandleChange = (event) => {
    setcpcValue(event.target.value)
  }
  const kindCodeHandleChange = (event) => {
    setkindCodeValue(event.target.value)
  }

  const handleClearSearch = () => {
    setPriorityDValue("")
    setPublicationDValue("")
    setcpcValue("")
    setkindCodeValue("")
    setPriorityCondition(P_VALUES[0])
    setPublicationCondition(P_VALUES[0])
  }

  const handlePriorityConditionChange = (event) => {
    setPriorityCondition(event.target.value)
  }
  const handlePublicationConditionChange = (event) => {
    setPublicationCondition(event.target.value)
  }


  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      runConversation()
    }
  }

  useEffect(() => {
    const initiallizeChat = async () => {
      setIsLoading(true)
      setError(null)

      const existingThreadId = localStorage.getItem("traindex_chat_thread_id")
      if (existingThreadId) {
        try {
          const data = await ChatbotApi.getThread(existingThreadId)
          setThreadData(data)
        } catch (error) {
          localStorage.removeItem("traindex_chat_thread_id")
          await createAndSetNewThread()
        }
      } else {
        await createAndSetNewThread()
      }

      setIsLoading(false)
    }

    const createAndSetNewThread = async () => {
      try {
        const data = await ChatbotApi.createThread()
        setThreadData(data)
        localStorage.setItem("traindex_chat_thread_id", data.id)
      } catch (err) {
        setError(err.message)
      }
    }
    initiallizeChat()
  }, [])

  const [loadingForGen, setLoadingForGen] = useState(false)
  const [promptInputValue, setpromptInputValue] = useState("")
  const [messages, setMessages] = useState([
    {
      text: "Hi! I am an assistant to help with Prior art\
  search and analysis, Patent drafting and much more.",
      isUser: false,
    },
  ])

  const getFilteredData = async (args) => {
    const payload = args

    var priority_sign = "<"
    var publication_sign = "<"

    if(priorityCondition == "Before"){
      priority_sign = "<"
    }
    else if(priorityCondition == "After"){
      priority_sign = ">"
    }
    else{
      priority_sign = "="
    }

    if(publicationCondition == "Before"){
      publication_sign = "<"
    }
    else if(publicationCondition == "After"){
      publication_sign = ">"

    }
    else{
      publication_sign = "="
    }

    if (priorityDValue != "" && payload["priority_date"] == undefined) {
      const pdValueWithoutDashs = priorityDValue.replace(/-/g, "")
      payload["priority_date"] = pdValueWithoutDashs
      payload["priority_date_criteria"] = priority_sign

    }
    if (publicationDValue != "" && payload["publication_date"] == undefined) {
      const pdValueWithoutDashs = publicationDValue.replace(/-/g, "")
      payload["publication_date"] = pdValueWithoutDashs
      payload["publication_date_criteria"] = publication_sign

    }
    if (cpcValue != "" && payload["cpc"] == undefined) {
      payload["cpc"] = cpcValue
    }
    if (kindCodeValue != "" && payload["kind_code"] == undefined) {
      payload["kind_code"] = kindCodeValue
    }
    const response = await TraindexApi.getFilteredData(payload)
    return response
  }

  const rerankPatentsForInvalidation = async (args) => {
    const payload = args

    var priority_sign = "<"
    var publication_sign = "<"

    if(priorityCondition == "Before"){
      priority_sign = "<"
    }
    else if(priorityCondition == "After"){
      priority_sign = ">"
    }
    else{
      priority_sign = "="
    }

    if(publicationCondition == "Before"){
      publication_sign = "<"
    }
    else if(publicationCondition == "After"){
      publication_sign = ">"
    }
    else{
      publication_sign = "="
    }

    if (priorityDValue != "" && payload["priority_date"] == undefined) {
      const pdValueWithoutDashs = priorityDValue.replace(/-/g, "")
      payload["priority_date"] = pdValueWithoutDashs
      payload["priority_date_criteria"] = priority_sign
    }
    if (publicationDValue != "" && payload["publication_date"] == undefined) {
      const pdValueWithoutDashs = publicationDValue.replace(/-/g, "")
      payload["publication_date"] = pdValueWithoutDashs
      payload["publication_date_criteria"] = publication_sign
    }
    if (cpcValue != "" && payload["cpc"] == undefined) {
      payload["cpc"] = cpcValue
    }
    if (kindCodeValue != "" && payload["kind_code"] == undefined) {
      payload["kind_code"] = kindCodeValue
    }

    const response = await TraindexApi.rerankPatents(payload)
    return response
  }

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

  const runConversation = async (event) => {
    const textarea = document.querySelector(".chatbot-input")
    if (textarea) {
      textarea.style.height = "auto"
    }

    const cloudWatchStruct = {}

    setLoadingForGen(true)
    const prompt = promptInputValue
    sendLogToCloudWatch("/aws/traindex_ui_frontend/dexi-request-logs", {user_query:prompt})

    cloudWatchStruct["1_user_query"] = prompt

    const startTime = performance.now()


    const userMessageUpdate = [...messages, { text: prompt, isUser: true }]
    setMessages(userMessageUpdate)
    setpromptInputValue("")

    const threadId = threadData["id"]

    await ChatbotApi.sendMessage(threadId, { content: prompt })
    const run = await ChatbotApi.runAssistant(threadId)

    var response_status = ""
    var statusCompleteRes = ""
    var patents = ""

    var anyError = false

    while (response_status != "completed") {
      await delay(3000)
      statusCompleteRes = await ChatbotApi.checkCompleteStatus(threadId, run["id"])
      if (statusCompleteRes["required_action"] != null) {
        var function_props = statusCompleteRes["required_action"]["submit_tool_outputs"]["tool_calls"]
        var tool_outputs = []

        for (let i = 0; i < function_props.length ; i++){

          var function_name = function_props[i]["function"]["name"]
          var function_args = JSON.parse(function_props[i]["function"]["arguments"])
          var function_tool_id = function_props[i]["id"]
  
          if (function_name == "traindex_API") {
            cloudWatchStruct["2_openai_to_v7_req"] = function_args
  
            patents = await getFilteredData(function_args)

            if (Object.prototype.hasOwnProperty.call(patents, "Error")){

              tool_outputs.push({"tool_call_id":function_tool_id, "output":JSON.stringify(patents, null, 2)})
              cloudWatchStruct["2_openai_to_v7_res"] = JSON.stringify(patents, null, 2)

            }
            else{
              const updated_patents = patents.map(item => ({
                ...item,  
                patent_text: "For Devs: Visit Google Patents to get patent text" 
              }))
  
              const jsonString = JSON.stringify(patents, null, 2)
  
              const formattedToolOutput = prettier.format(jsonString, {
                parser: "json",
                plugins: [parserBabel],
              })
  
              tool_outputs.push({"tool_call_id":function_tool_id, "output":formattedToolOutput})
    
              cloudWatchStruct["2_openai_to_v7_res"] = updated_patents

            }

          }
          if (function_name == "get_full_patent_text") {
            cloudWatchStruct["2_ucid_for_details_req"] = function_args

            patents = await TraindexApi.getPatentText(function_args)

            const jsonString = JSON.stringify(patents, null, 2)

            const formattedToolOutput = prettier.format(jsonString, {
              parser: "json",
              plugins: [parserBabel],
            })
            tool_outputs.push({"tool_call_id":function_tool_id, "output":formattedToolOutput})

            
            var patents_res = ""
            if (patents["patent_text"] == undefined){
              patents_res = patents["response"]
            }
            else{
              patents_res = patents["patent_text"].substring(0,200)
  
            }
  
            cloudWatchStruct["2_ucid_for_details_res"] = patents_res
          }

          if (function_name == "rerank_patents_for_invalidation") {
            cloudWatchStruct["2_ucid_for_details_req"] = function_args
            patents = await rerankPatentsForInvalidation(function_args)

            const jsonString = JSON.stringify(patents, null, 2)

            const formattedToolOutput = prettier.format(jsonString, {
              parser: "json",
              plugins: [parserBabel],
            })
            tool_outputs.push({"tool_call_id":function_tool_id, "output":formattedToolOutput})

            
            var inv_patents_res = ""
            if (patents["patent_text"] == undefined){
              inv_patents_res = patents["response"]
            }
            else{
              inv_patents_res = patents["patent_text"].substring(0,200)
  
            }
  
            cloudWatchStruct["2_ucid_for_details_res"] = inv_patents_res
          }
        }

        try {
          await ChatbotApi.submitToolOutputs({
            thread_id: threadId,
            run_id: run["id"],
            tool_outputs: tool_outputs,
          })
        } catch (error) {
          break
        }
      }
      response_status = statusCompleteRes["status"]
    }
    var res = ""
    if (!anyError){
      const thread_messages = await ChatbotApi.getMessages(threadId)
      res = thread_messages.data[0].content[0].text.value
    }
    else {
      res = "Sorry aboout that. There is some internal error! Try again later"
    }

    cloudWatchStruct["3_user_res"] = res

    const words = res.trim() === "" ? 0 : res.trim().split(/\s+/).length
    const size = new Blob([res]).size
    const tokens = res.match(/\S+/g) || []

    const sizeInKB = (size / 1024).toFixed(2)

    cloudWatchStruct["no_of_words"] = words
    cloudWatchStruct["size_of_res"] = Number(sizeInKB)
    cloudWatchStruct["no_of_tokens"] = tokens.length

    const dexiMessageUpdate = [...userMessageUpdate, { text: res, isUser: false }]
    setMessages(dexiMessageUpdate)

    const endTime = performance.now()
    const executionTime = endTime - startTime
    
    const seconds_executionTime = executionTime / 1000
    sendToCloudWatch(seconds_executionTime)

    setLoadingForGen(false)
    sendLogToCloudWatch("/aws/traindex_ui_frontend/dexi-response-logs", cloudWatchStruct)
  }

  const handlePromptInputChange = (e) => {
    setpromptInputValue(e.target.value)
    const textarea = e?.target
    if (textarea) {
      if (textarea.value.trim() === "") {
        textarea.style.height = "auto"
      } else {
        textarea.style.height = "auto"
        textarea.style.height = `${Math.min(textarea.scrollHeight, 100)}px`
      }
    }
  }

  return (
    <div className="px-1">
      {!authorize && <Header dark chatbot />}
      <div className="d-flex justify-content-center px-1 mt-5">
        <Container className="mt-4 mx-auto">
          <Row className="d-flex justify-content-between ">
            <Col className="d-flex flex-column col-12 col-md-3 mb-3">
              <Filter
                priorityDValue={priorityDValue}
                publicationDValue={publicationDValue}
                cpcValue={cpcValue}
                kindCodeValue={kindCodeValue}
                priorityCondition={priorityCondition}
                publicationCondition={publicationCondition}
                onChangePriorityD={handlePriorityDChange}
                onChangePublicationD={handlePublicaionDChange}
                cpcHandleChange={cpcHandleChange}
                kindCodeHandleChange={kindCodeHandleChange}
                handleClearSearch={handleClearSearch}
                onChangePriorityCondition={handlePriorityConditionChange}
                onChangePublicationCondition={handlePublicationConditionChange}
              />
              {messages && <Feedback messages={messages} />}
            </Col>
            <Col className="col-12 col-md-9">
              <ChatContainer
                messages={messages}
                loadingForGen={loadingForGen}
                isLoading={isLoading}
                error={error}
                promptInputValue={promptInputValue}
                onPromptInputChange={handlePromptInputChange}
                handleKeyDown={handleKeyDown}
                runConversation={runConversation}
              />
            </Col>
          </Row>
        </Container>
      </div>
      {!authorize && <Footer home />}
    </div>
  )
}

Chatbot.propTypes = {
  history: PropTypes.object.isRequired,
}

export default Chatbot
